import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap, HeartHandshake, Award } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { IMAGES } from "@/data/site";

const stats = [
  { icon: Award, value: "10+", label: "Years Experience" },
  { icon: HeartHandshake, value: "5,000+", label: "Patients Treated" },
  { icon: GraduationCap, value: "Certified", label: "Implantologist" },
];

export const MeetDoctor = () => (
  <section data-testid="meet-doctor-section" className="bg-white">
    <div className="mx-auto grid max-w-[1440px] items-center gap-12 px-6 py-24 md:px-12 md:py-32 lg:grid-cols-2 lg:gap-20 lg:px-20 lg:py-40">
      <Reveal className="relative">
        <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem]">
          <img src={IMAGES.doctor} alt="Dr. Ankesh Kr. Seth, dentist in Varanasi" loading="lazy" className="h-full w-full object-cover" />
        </div>
        <div className="absolute -bottom-6 -right-2 grid grid-cols-3 gap-3 rounded-2xl border border-brand-line bg-white p-5 shadow-[0_30px_60px_-30px_rgba(5,16,26,0.4)] md:-right-6">
          {stats.map((s) => (
            <div key={s.label} className="px-2 text-center">
              <s.icon className="mx-auto mb-1 h-5 w-5 text-brand-blue" />
              <div className="font-display text-2xl font-bold text-brand-dark">{s.value}</div>
              <div className="text-[11px] leading-tight text-brand-muted">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
          Meet Your Dentist
        </span>
        <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl">
          Meet Dr. Ankesh Seth, your <span className="italic text-brand-blue">trusted</span> dentist
          in Varanasi
        </h2>
        <div className="mt-6 space-y-4 text-brand-muted">
          <p>
            Dr. Ankesh Seth is an experienced Dental Surgeon, Implantologist and Cosmetic Dentist
            with 10+ years of clinical experience and over 5,000 patients successfully treated.
            Practising at NowTreat Dental Clinic in Paharia, he is committed to ethical,
            patient-centred care.
          </p>
          <p>
            Backed by a Fellowship in Oral Implantology (GCOI Europe) and advanced international
            training, he listens carefully, explains every treatment clearly, and never recommends
            more than you truly need — combining modern technology with genuinely gentle dentistry.
          </p>
        </div>
        <Link
          to="/dr-ankesh-seth"
          data-testid="meet-doctor-cta"
          className="group mt-8 inline-flex items-center gap-2 rounded-full border border-brand-blue px-6 py-3 text-sm font-semibold text-brand-blue transition-all hover:bg-brand-blue hover:text-white"
        >
          Learn More About Dr. Ankesh Seth
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);
